/**
 * Where a draft stands, read from its latest run alone: the run the Generate
 * page serves, so the draft list and the Generate page never disagree.
 */

import type { TaskSummary } from "@patent-studio/api-types";

/** Delivered: the bucket the server serves by the client card's own rule. */
export function isCompleted(draft: TaskSummary): boolean {
  return draft.bucket === "completed";
}

/** A run is queued or drafting, so the draft's details are fixed. */
export function isGenerating(draft: TaskSummary): boolean {
  const state = draft.latest_run?.state;
  return state === "queued" || state === "running";
}

/** The last run failed or a check stopped it, so the attorney has something to do. */
export function needsAttention(draft: TaskSummary): boolean {
  const state = draft.latest_run?.state;
  return state === "failed" || state === "stopped";
}
